export default "__VITE_ASSET__BxGsCeUv__"